export default __webpack_public_path__ + "static/media/header-image.74892b57.svg";